module.exports = __webpack_public_path__ + "static/img/tubiao_jinse_2.95c4375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/tubiao_jinse_2.png
// module id = gcIN
// module chunks = 2